import script from "./AutoLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoLogin.vue?vue&type=script&setup=true&lang=ts"

import "./AutoLogin.vue?vue&type=style&index=0&id=2ff1109a&scoped=true&lang=css"

import exportComponent from "/Users/alessiomealli/WebstormProjects/switaly/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ff1109a"]])

export default __exports__